import { InvalidDeviceGroupVaultEntryError } from './invalid-device-group-vault-entry-error';
export class InvalidDeviceGroupVaultEntrySignatureError extends InvalidDeviceGroupVaultEntryError {
    constructor(signatureName, entry) {
        super(`'${signatureName}' signature of entry '${entry.entryId}' is invalid.`, entry);
        this.entry = entry;
        this.name = 'InvalidDeviceGroupVaultEntrySignatureError';
        this.entry = entry;
    }
}
